import HeaderSearch from "./header-search.vue";

window.Vue.createApp({
    components: {
        HeaderSearch,
    },
}).mount("#hybrid-bar");
